import 'react';
import '../uniqueId.js';
import 'prop-types';
import '../types/props.js';
import { css } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import Flex from 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import Spinner from '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import Button from '../Button/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import Icon from '../Icon/index.js';
import '../VisuallyHidden.js';
import '../Text/styled.js';
import '../Text/index.js';
import 'reakit/Navigation';
import '../Navigation/styled.js';
import '../chunk-18be6601.js';
import '../Navigation/index.js';
import 'conditional-wrap';
import '../adaptors/fields.js';
import 'reakit/Label';
import 'reakit/Input';
import 'reakit/Hidden';
import '../Hidden/HiddenContainer.js';
import '../Hidden/styled.js';
import '../Hidden/HiddenShow.js';
import '../Hidden/HiddenHide.js';
import '../Hidden/HiddenToggle.js';
import '../Hidden/index.js';
import '../chunk-5c9bbccf.js';
import 'reakit/Popover';
import '../Popover/PopoverContainer.js';
import '../Popover/styled.js';
import '../Popover/PopoverHide.js';
import '../Popover/PopoverClose.js';
import 'focus-trap';
import '../chunk-abb87050.js';
import '../Popover/PopoverPopover.js';
import '../Popover/PopoverShow.js';
import '../Popover/PopoverToggle.js';
import '../chunk-8dd1e1d3.js';
import '../chunk-1195bf9a.js';
import 'reakit/Field';
import '../Label/styled.js';
import '../Label/index.js';
import '../FieldWrapper/styled.js';
import 'reakit/Divider';
import '../Divider/styled.js';
import '../Divider/index.js';
import 'reakit/Group';
import '../Group/styled.js';
import '../Group/index.js';
import 'react-input-mask';
import '../Input/styled.js';
import '../Input/InputField-2fb729da.js';
import Input from '../Input/index.js';
import '../Popover/index.js';
import { MenuGroupTitle } from '../Menu/styled.js';
import '../Menu/MenuContext.js';
import '../Menu/MenuTrigger.js';
import '../Menu/MenuButton.js';
import '../Menu/MenuDivider.js';
import '../Menu/MenuGroup.js';
import '../Menu/MenuItem.js';
import '../Menu/MenuPopover.js';
import Menu from '../Menu/index.js';
import '../Tag/styled.js';
import Tag from '../Tag/index.js';

var SelectMenuItem = styled(Menu.Item).withConfig({
  displayName: "styled__SelectMenuItem",
  componentId: "sc-1mfdpmr-0"
})(["font-weight:", ";&[disabled]{", ";}&:not(:disabled):focus{", ";}&:not(:disabled):hover{", ";}", ";", ";"], theme('fannypack.fontWeights.normal'), theme('fannypack.SelectMenu.Item.disabled'), theme('fannypack.SelectMenu.Item.focus'), theme('fannypack.SelectMenu.Item.hover'), function (props) {
  return props.isActive && css(["background-color:", ";color:", ";&&:hover,&&:focus{background-color:", ";}&&:hover:active{background-color:", ";}&{", ";}"], palette('primary'), palette('white'), palette('primary600'), palette('primary700'), theme('fannypack.SelectMenu.Item.active'));
}, theme('fannypack.SelectMenu.Item.base'));
var SelectMenuIcon = styled.svg.withConfig({
  displayName: "styled__SelectMenuIcon",
  componentId: "sc-1mfdpmr-1"
})(["position:absolute;width:20px;height:20px;right:2px;z-index:1;fill:", ";", ";"], palette('text'), theme('fannypack.SelectMenu.Icon.base'));
var SelectMenuLoadingSpinner = styled(Spinner).withConfig({
  displayName: "styled__SelectMenuLoadingSpinner",
  componentId: "sc-1mfdpmr-2"
})(["position:absolute;top:10px;right:7px;z-index:1;", ";"], theme('fannypack.SelectMenu.LoadingSpinner.base'));
var SelectMenuStaticItem = styled(Flex).withConfig({
  displayName: "styled__SelectMenuStaticItem",
  componentId: "sc-1mfdpmr-3"
})(["justify-content:center;padding:0.5rem 0;", ";"], theme('fannypack.SelectMenu.StaticItem.base'));
var SelectMenuLoadingItemSpinner = styled(Spinner).withConfig({
  displayName: "styled__SelectMenuLoadingItemSpinner",
  componentId: "sc-1mfdpmr-4"
})(["", ";"], theme('fannypack.SelectMenu.LoadingItemSpinner.base'));
var SelectMenuButton = styled(Menu.Button).withConfig({
  displayName: "styled__SelectMenuButton",
  componentId: "sc-1mfdpmr-5"
})(["background:linear-gradient(rgb(255,255,255),rgb(249,250,251));padding-right:", "rem;font-weight:", ";", ";"], space(8), theme('fannypack.fontWeights.normal'), theme('fannypack.SelectMenu.Button.base'));
var SelectMenuDivider = styled(Menu.Divider).withConfig({
  displayName: "styled__SelectMenuDivider",
  componentId: "sc-1mfdpmr-6"
})(["", ";"], theme('fannypack.SelectMenu.Divider.base'));
var SelectMenuGroup = styled(Menu.Group).withConfig({
  displayName: "styled__SelectMenuGroup",
  componentId: "sc-1mfdpmr-7"
})(["margin:0;overflow-y:auto;max-height:300px;", ";", ";"], function (props) {
  return props.isDropdown && css(["&{max-height:230px;}"]);
}, theme('fannypack.SelectMenu.Group.base'));
var SelectMenuGroupTitle = styled(MenuGroupTitle).withConfig({
  displayName: "styled__SelectMenuGroupTitle",
  componentId: "sc-1mfdpmr-8"
})(["", ";"], theme('fannypack.SelectMenu.Group.title'));
var SelectMenuItemIcon = styled(Icon).withConfig({
  displayName: "styled__SelectMenuItemIcon",
  componentId: "sc-1mfdpmr-9"
})(["", ";"], theme('fannypack.SelectMenu.Item.icon'));
var SelectMenuPopover = styled(Menu.Popover).withConfig({
  displayName: "styled__SelectMenuPopover",
  componentId: "sc-1mfdpmr-10"
})(["width:250px;", ";"], theme('fannypack.SelectMenu.Popover.base'));
var SelectMenuSearchInput = styled(Input).withConfig({
  displayName: "styled__SelectMenuSearchInput",
  componentId: "sc-1mfdpmr-11"
})(["& input{border:none;border-bottom:1px solid ", ";border-bottom-left-radius:0px;border-bottom-right-radius:0px;box-shadow:none;width:100%;&:focus{border-bottom:none;box-shadow:", " inset 0px 0px 0px 2px !important;}}", ";"], palette('white900'), function (props) {
  return palette('primary')(props);
}, theme('fannypack.SelectMenu.SearchInput.base'));
var SelectMenuSection = styled(Box).withConfig({
  displayName: "styled__SelectMenuSection",
  componentId: "sc-1mfdpmr-12"
})(["background:", ";width:100%;"], palette('white600'));
var SelectMenuBottomSection = styled(SelectMenuSection).withConfig({
  displayName: "styled__SelectMenuBottomSection",
  componentId: "sc-1mfdpmr-13"
})(["border-top:1px solid ", ";display:flex;justify-content:space-between;padding:", "rem ", "rem;", ";"], palette('white900'), space(1), space(2), theme('fannypack.SelectMenu.BottomSection.base'));
var SelectMenuTopSection = styled(SelectMenuSection).withConfig({
  displayName: "styled__SelectMenuTopSection",
  componentId: "sc-1mfdpmr-14"
})(["border-bottom:1px solid ", ";padding:", "rem;", ";"], palette('white900'), space(2), theme('fannypack.SelectMenu.TopSection.base'));
var SelectMenuActionButton = styled(Button).withConfig({
  displayName: "styled__SelectMenuActionButton",
  componentId: "sc-1mfdpmr-15"
})(["font-size:", "rem;padding:0 ", "rem;", ";"], theme('fannypack.fontSizes.100'), space(2), theme('fannypack.SelectMenu.ActionButton.base'));
var SelectMenuTag = styled(Tag).withConfig({
  displayName: "styled__SelectMenuTag",
  componentId: "sc-1mfdpmr-16"
})(["", ";"], theme('fannypack.SelectMenu.Tag.base'));
var SelectMenu = styled(Menu).withConfig({
  displayName: "styled__SelectMenu",
  componentId: "sc-1mfdpmr-17"
})(["", ";"], theme('fannypack.SelectMenu.base'));

export default SelectMenu;
export { SelectMenu, SelectMenuActionButton, SelectMenuBottomSection, SelectMenuButton, SelectMenuDivider, SelectMenuGroup, SelectMenuGroupTitle, SelectMenuIcon, SelectMenuItem, SelectMenuItemIcon, SelectMenuLoadingItemSpinner, SelectMenuLoadingSpinner, SelectMenuPopover, SelectMenuSearchInput, SelectMenuSection, SelectMenuStaticItem, SelectMenuTag, SelectMenuTopSection };
